import React, { useEffect } from "react";
import { Switch, useRouteMatch } from "react-router-dom";
import PrivateRoute from "../../../../Routes/PrivateRoutes";
import FluxoEventosProvider from "./FluxoEventosContext";
import PesquisarFluxoEventos from "./Events/PesquisarFluxoEventos";
import FormularioFluxoEventos from "./Events/FormularioFluxoEventos";
import { LoadMask } from "../../../../Utils/mask";

const Index = () => {
  let match = useRouteMatch();
  useEffect(() => {
    LoadMask();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <FluxoEventosProvider>
      <div className="container-fluid pl-3 pt-3 pb-3">
        <Switch>
          <PrivateRoute
            exact
            path={`${match.url}`}
            component={PesquisarFluxoEventos}
          />
          <PrivateRoute
            path={`${match.url}/:id`}
            component={FormularioFluxoEventos}
          />
        </Switch>
      </div>
    </FluxoEventosProvider>
  );
};

export default Index;
